// Каталог тарифов Resstro.
// Основной источник, публичный эндпоинт `/api/public/plans` (см. `lib/publicApi.ts`).
// Данные ниже, статический fallback на случай сетевой ошибки, чтобы лендинг
// никогда не отображался «пустым».
//
// Структура 1-в-1 с ответом API (поля в рублях, не копейках).

export interface PublicPlan {
  code: 'single' | 'start' | 'business' | 'network' | string;
  name: string;
  tagline: string | null;
  description: string | null;
  priceMonth: number;
  priceYear: number;
  monthlySavingsPct: number;
  extraEstablishmentPriceMonth: number | null;
  maxEstablishments: number | null;
  maxCashiers: number | null;
  maxUsers: number | null;
  features: string[];
  highlights: string[];
  isPopular: boolean;
}

export const FALLBACK_PLANS: PublicPlan[] = [
  {
    code: 'single',
    name: 'Resstro',
    tagline: 'Один тариф для ресторана и для сети',
    description:
      'Все возможности Resstro за 2 500 ₽ в месяц за заведение. ' +
      'Добавляете точку и платите ещё 2 500 ₽ за неё. Ничего лишнего.',
    priceMonth: 2500,
    priceYear: 25000,
    monthlySavingsPct: 17, // 2500×12=30000 → 25000 ≈ −17%
    extraEstablishmentPriceMonth: 2500,
    maxEstablishments: null,
    maxCashiers: 1,
    maxUsers: 10,
    features: [
      'export_reports',
      'online_payments',
      'advanced_analytics',
      'unlimited_history',
      'audit_log',
      'priority_support',
    ],
    highlights: [
      '2 500 ₽ в месяц за одно заведение (одна касса на точку)',
      'Каждое следующее заведение: ещё 2 500 ₽ в месяц',
      'Все точки в одном кабинете, переключение в один клик',
      'Гость оплачивает заказ картой в телефоне, не дожидаясь официанта (ЮKassa)',
      'Видно, какие блюда приносят прибыль и сколько продаёт каждый официант',
      'Журнал действий: кто отменил заказ, изменил цену или удалил блюдо',
      'Выгрузка отчётов в Excel и PDF',
      'Поддержка в WhatsApp с быстрым ответом',
    ],
    isPopular: true,
  },
];

// ─── Модули (add-ons) ──────────────────────────────────────────────────
// Витрина на лендинге. Источник, `/api/public/addons`; ниже статический fallback
// (поля в рублях, 1-в-1 с ответом API).
export interface PublicAddon {
  code: string;
  name: string;
  description: string;
  priceMonth: number;
}

export const FALLBACK_ADDONS: PublicAddon[] = [
  {
    code: 'ofd',
    name: 'Интеграция с ОФД / фискальные чеки',
    description: 'Автоматическая отправка чеков оператору фискальных данных по 54-ФЗ.',
    priceMonth: 990,
  },
  {
    code: 'egais',
    name: 'ЕГАИС + Честный ЗНАК',
    description: 'Учёт алкоголя и маркированной продукции.',
    priceMonth: 1490,
  },
  {
    code: 'aggregators',
    name: 'Агрегаторы доставки',
    description: 'Яндекс.Еда, Delivery Club и Самокат: заказы падают прямо в кассу.',
    priceMonth: 1490,
  },
  {
    code: 'loyalty',
    name: 'Модуль лояльности',
    description: 'Бонусы, промокоды, программа удержания гостей.',
    priceMonth: 990,
  },
  {
    code: 'sms',
    name: 'SMS-уведомления гостям',
    description: 'Абонплата + оплата по факту отправленных SMS.',
    priceMonth: 590,
  },
  {
    code: 'extra_cashier',
    name: 'Дополнительная касса',
    description: 'Сверх лимита тарифа. Цена за одно устройство.',
    priceMonth: 490,
  },
  {
    code: 'extra_user',
    name: 'Дополнительный сотрудник',
    description: 'Сверх лимита тарифа. Цена за одного сотрудника.',
    priceMonth: 190,
  },
  {
    code: 'waiters',
    name: 'Официанты',
    description:
      'Приложение Resstro Официант: заказ со стола сразу на кассе и кухне, оплата и пречек с телефона. Цена за заведение.',
    priceMonth: 500,
  },
];
